let React = require("react");
let PropTypes = require("prop-types");

export const DoubleClickAd = ({ style, row = 0 }) => {
    // The adId needs to be at least somewhat unique so the ad doesn't get
    // loaded from a cache.
    // https://support.google.com/dcm/answer/2837459?hl=en
    // https://support.google.com/dcm/answer/2837435
    let [adId] = React.useState(Math.random() * 1000000000000000000);

    // Define multiple ads we can rotate through on a single page of results.
    // Make sure to replace ord=[timestamp] with ord=${adId} in src urls when
    // you update these.
    const ads = [
        {
            iframeSrc: `https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B25217633.318383550;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`,
            scriptSrc: `https://ad.doubleclick.net/ddm/adj/N718679.3040413THENOUNPROJECT.CO/B25217633.318383550;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`
        },
        {
            iframeSrc: `https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B25217633.318584932;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`,
            scriptSrc: `https://ad.doubleclick.net/ddm/adj/N718679.3040413THENOUNPROJECT.CO/B25217633.318584932;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`
        },
        {
            iframeSrc: `https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B25217633.318585145;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`,
            scriptSrc: `https://ad.doubleclick.net/ddm/adj/N718679.3040413THENOUNPROJECT.CO/B25217633.318585145;sz=728x90;ord=${adId};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`
        }
    ];

    const ad = ads[row % ads.length]; // Pick an ad from the collection
    return (
        <iframe
            src={ad.iframeSrc}
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            height="90"
            width="728"
            // eslint-disable-next-line react/no-unknown-property
            allowtransparency="1"
            style={{ ...style, border: "none" }}
        >
            <script src={ad.scriptSrc} />
        </iframe>
    );
};

DoubleClickAd.defaultProps = {
    style: {
        margin: "30px auto 0"
    }
};

DoubleClickAd.propTypes = {
    style: PropTypes.object
};
